/* app/ui/announcements*/
define(
    'app/ui/announcement/announcements',[
        'jquery'

    ],
    function ($) {
        var Announcements;
        var $announcement = $('.js-announcements');
        var $announceCloseBtn = $('.js-announcements__close-btn');
        var userData;
        var storageKey = 'dglt-user-announcements';
        var announcementId;
        var announcementsHeight = 0;
        var $window = $(window);

        var classes = {
            expanded: 'is-expanded',
            collapsed: 'is-collapsed',
            sticky: 'is-sticky',
            hide: 'is-hidden'
        };


        return {
            init: function () {
                Announcements = this;
                if (typeof localStorage === 'object' && localStorage.setItem !== undefined) {
                    Announcements._initEvents();
                }
            },
            _initEvents: function () {
                Announcements._checkAnnouncement();
                $announceCloseBtn.on('click', Announcements._hideNotification);
            },

            _hideNotification: function () {
                event.preventDefault();
                userData = $announcement.attr('data-announcement-id');
                localStorage.setItem(storageKey, userData);
                $announcement.remove();
            },

            _checkAnnouncement: function () {
                announcementId = localStorage.getItem(storageKey);
                if (announcementId) {
                    userData = $announcement.attr('data-announcement-id');
                    if (userData == announcementId) {
                        $announcement.remove();
                    } else {
                        $announcement.addClass('c-announcements--visible');

                        return;
                    }
                } else {
                    $announcement.addClass('c-announcements--visible');

                        return;
                }
            }

        };
    }
);
